<template>
  <div>
    <div class="text-xs-right">
      <v-btn @click="$emit('close')" icon> <v-icon>close</v-icon></v-btn>
    </div>
    <div class="px-4 pb-4">
      <div style="font-weight: 600; font-size: 22px" class="primary--text mb-3">
        รายละเอียดโพสต์
      </div>
      <div class="form-control" :class="{ 'has-error': errors.has('ชื่อโพสต์') }">
        <input
          :disabled="edittype == 'read'"
          placeholder="กรอกชื่อโพสต์"
          v-model="input.name"
          type="text"
          name="ชื่อโพสต์"
          v-validate="'required'"
        />
        <p class="text-error" v-if="errors.has('ชื่อโพสต์')">
          {{ errors.first('ชื่อโพสต์') }}
        </p>
      </div>
      <div class="my-3">
        <v-divider></v-divider>
      </div>
      <div class="form-control" :class="{ 'has-error': errors.has('เลือกประเภท') }">
        <v-radio-group
          :disabled="edittype == 'read'"
          row
          v-model="radiochannel"
          v-validate="'required'"
          name="เลือกประเภท"
        >
          <v-radio label="เลือกเพจทั้งหมด" value="all" color="primary"></v-radio>
          <v-radio label="เลือกเฉพาะเพจ" value="custom" color="primary"></v-radio>
        </v-radio-group>
        <p class="text-error" v-if="errors.has('เลือกประเภท')">
          {{ errors.first('เลือกประเภท') }}
        </p>
      </div>
      <div class="mb-3">
        <div
          v-if="radiochannel == 'custom'"
          class="form-control"
          :class="{ 'has-error': errors.has('เลือกกลุ่ม') }"
        >
          <multiselect
            :loading="loadinggroup"
            @input="onChangeGroup"
            :disabled="edittype == 'read'"
            placeholder="เลือกกลุ่ม"
            name="เลือกกลุ่ม"
            track-by="id"
            label="name"
            :options="groupOptionsFiltered"
            :show-labels="false"
            :custom-label="customLabel"
          >
          </multiselect>
          <p class="text-error" v-if="errors.has('เลือกกลุ่ม')">
            {{ errors.first('เลือกกลุ่ม') }}
          </p>
        </div>
      </div>
      <div>
        <div
          v-if="radiochannel == 'custom'"
          class="form-control"
          :class="{ 'has-error': errors.has('เลือกเพจ') }"
        >
          <multiselect
            :disabled="edittype == 'read'"
            v-validate="'required'"
            placeholder="เลือกเพจ"
            name="เลือกเพจ"
            track-by="channelid"
            :key="keychannels"
            label="channelname"
            v-model="input.channellist"
            :options="filteredChannels"
            @remove="keychannels++"
            multiple
            :show-labels="false"
          >
          </multiselect>
          <p class="text-error" v-if="errors.has('เลือกเพจ')">
            {{ errors.first('เลือกเพจ') }}
          </p>
        </div>
      </div>
      <div class="form-control mt-4" :class="{ 'has-error': errors.has('ลิงค์โพสต์') }">
        <input
          :disabled="edittype == 'read'"
          placeholder="กรอกลิงค์โพสต์"
          v-model="input.sharelink"
          type="text"
          name="ลิงค์โพสต์"
          v-validate="'required'"
        />
        <p class="text-error" v-if="errors.has('ลิงค์โพสต์')">
          {{ errors.first('ลิงค์โพสต์') }}
        </p>
      </div>
      <div class="form-control mt-4" :class="{ 'has-error': errors.has('คำบรรยาย') }">
        <textarea
          :disabled="edittype == 'read'"
          class="form-control"
          rows="5"
          name="คำบรรยาย"
          v-validate="'required'"
          v-model="input.messages"
          style="resize: vertical; min-height: 90px"
          :placeholder="'เพิ่มคำบรรยาย'"
        ></textarea>
        <p class="text-error" v-if="errors.has('คำบรรยาย')">
          {{ errors.first('คำบรรยาย') }}
        </p>
      </div>
      <div class="mb-3">
        <v-checkbox
          :disabled="edittype == 'read'"
          v-model="input.signaturestatus"
          :label="`ใช้ Signature`"
        ></v-checkbox>
      </div>
      <!-- <div class="mb-3">
        <UploadMultipleFile
          v-model="input.photoUrl"
          :max="50"
          :readonly="edittype == 'read'"
          data-vv-name="uploadMultipleFile"
          data-vv-as="Preview Image"
        ></UploadMultipleFile>
      </div> -->
      <div v-if="edittype !== 'read'" class="text-xs-center">
        <v-btn @click="$emit('close')" outline color="grey">ยกเลิก</v-btn>
        <v-btn :loading="saveloading" @click="onSave(false)" outline color="grey"
          >บันทึกฉบับร่าง</v-btn
        >
        <v-btn :loading="saveloading" @click="onSave(true)" depressed color="primary">
          {{ edittype == 'edit' ? 'โพสต์' : 'โพสต์' }}
        </v-btn>
      </div>
    </div>
  </div>
</template>

<script>
import api from '@/api'
// import UploadMultipleFile from './UploadMultipleFile.vue'
import multiselect from 'vue-multiselect'
import { mapGetters } from 'vuex'
export default {
  components: {
    multiselect
    // UploadMultipleFile
  },
  props: ['edittype', 'editdata', 'channels', 'groupOptions', 'loadinggroup'],
  computed: {
    groupOptionsFiltered() {
      if (this.groupOptions && this.groupOptions.length) {
        return this.groupOptions.map((group) => {
          var channels = this.filteredChannels.filter((val) =>
            val.groupids ? val.groupids.includes(parseInt(group.id)) : false
          )
          return {
            ...group,
            total: channels.length,
            $isDisabled: channels.length == 0
          }
        })
      } else return []
    },
    ...mapGetters(['selectedBot']),
    filteredChannels() {
      this.keychannels++
      return this.channels.filter((el) => {
        return el.app == 'facebook'
      })
    }
  },
  data() {
    return {
      keychannels: 0,
      saveloading: false,
      radiochannel: '',
      selectedGroup: '',
      input: {
        name: '',
        sharelink: '',
        // photoUrl: [],
        channellist: []
      }
    }
  },
  mounted() {
    if (this.edittype == 'edit' || this.edittype == 'read') {
      this.input = this.editdata
      this.input.sharelink = this.editdata.sharelink
      // if (this.editdata.photourl) {
      //   this.input.photoUrl = this.editdata.photourl.split(',')
      // }
      this.radiochannel = 'custom'

      this.input.channellist = this.filteredChannels.filter((el) => {
        return this.editdata.channelidlist.includes(el.channelid)
      })
      this.keychannels++
      this.input.signaturestatus = this.editdata.signaturestatus
    } else {
      this.input.signaturestatus = true
    }
  },
  methods: {
    customLabel(item) {
      return `${item.name} (${item.total})`
    },
    onChangeGroup(group) {
      this.input.channellist = this.filteredChannels.filter((el) =>
        el.groupids ? el.groupids.includes(parseInt(group.id)) : false
      )
      this.keychannels++
    },
    async onSave(isPublish) {
      if (await this.$validator.validate()) {
        if (this.edittype == 'create') {
          this.createData(isPublish)
        } else {
          this.editData(isPublish)
        }
      }
    },
    sendPost(data) {
      api.powerbuySendFacebookSharePost(data, (err, response) => {
        this.saveloading = false
        if (response.responsecode == 200) {
          this.$emit('onSave')
        }
      })
    },
    createData(isPublish) {
      this.saveloading = true
      if (this.radiochannel == 'all') {
        var channelIdList = this.filteredChannels.map((el) => el.channelid)
      } else {
        var channelIdList = this.input.channellist.map((el) => el.channelid)
      }
      var data = {
        pageid: this.selectedBot.pageid,
        name: this.input.name,
        channelIdList, // array channelid
        messages: this.input.messages,
        shareLink: this.input.sharelink,
        // photoUrl: this.input.photoUrl.join(','),
        publish: isPublish, // boolean >> true คือโพสต์ไป facebook, false คือ แบบร่าง
        signatureStatus: this.input.signaturestatus
      }
      api.powerbuyCreateFacebookShearPost(data, (err, response) => {
        if (isPublish) {
          this.sendPost(data)
        } else {
          this.saveloading = false
          this.$emit('onSave')
        }
      })
    },
    editData(isPublish) {
      this.saveloading = true
      if (this.radiochannel == 'all') {
        var channelIdList = this.filteredChannels.map((el) => el.channelid)
      } else {
        var channelIdList = this.input.channellist.map((el) => el.channelid)
      }

      var data = {
        id: this.editdata.id,
        pageid: this.selectedBot.pageid,
        name: this.input.name,
        shareLink: this.input.sharelink,
        channelIdList, // array channelid
        messages: this.input.messages,
        // photoUrl: this.input.photoUrl && this.input.photoUrl.length ? this.input.photoUrl.join(',') : '',
        publish: isPublish, // boolean >> true คือโพสต์ไป facebook, false คือ แบบร่าง
        signatureStatus: this.input.signaturestatus // boolean >> true คือใช้ signature
      }
      api.powerbuyEditFacebookShearPost(data, (err, response) => {
        if (isPublish) {
          this.sendPost(data)
        } else {
          this.saveloading = false
          this.$emit('onSave')
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/powerbuy/FacebookShearPostManager/PostEdit.vue